module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 18,
      "md": 14
    }
  }, [_c('div', {
    staticClass: "release-content"
  }, [_c('div', {
    staticClass: "content-inner full-w"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('static.releaseNote.page.subTitle')))]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('static.releaseNote.page.title')))])]), _vm._v(" "), _vm._l((_vm.releaseNotes), function(releaseNote) {
    return _c('div', {
      staticClass: "release-note"
    }, [_c('h2', [_vm._v(_vm._s(_vm.formatDate(releaseNote.createdAt)) + "  "), _c('small', [_vm._v("v." + _vm._s(releaseNote.version))]), _vm._v("  "), _c('el-tag', {
      attrs: {
        "size": "small"
      }
    }, [_c('i', {
      staticClass: "el-icon-document"
    }), _vm._v(" " + _vm._s(releaseNote.module.toUpperCase()))])], 1), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(releaseNote.description)
      }
    })])
  })], 2)])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32269c02","hasScoped":false}!./src/app/pages/home/releaseNotes/releaseNotes.html
// module id = 2961
// module chunks = 1